// extracted by mini-css-extract-plugin
export default {"switch":"switch_switch__GxTl-","checkbox":"switch_checkbox__MGnqA"};